<template>
  <span
    v-if="count > 0"
    class="unseen-count badge-secondary"
  >
    {{ count < 100 ? count : '99+' }}
  </span>
</template>

<script>
export default {
  name: 'NotificationBadge',
  data() {
    return {
      count: 0,
    };
  },
  mounted() {
    this.getCount();
    this.$root.$on('ws:notification', data => {
      this.count = data.unread;
    });
    this.$root.$on('ws:notification:count', data => {
      this.count = data;
    });
  },
  methods: {
    async getCount() {
      const response = await this.api({
        url: 'notifications/count/',
      });
      if (response.status === 200) {
        this.count = response.body.count;
      }
      return this.count;
    },
  },
}
</script>
